import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Column } from "primereact/column";
import { SplitButton } from "primereact/splitbutton";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import {
  getApprovedMembersbyCategory,
  getApprovedMembersforPrint,
  getCityWiseCount,
  getMemberCount,
  searchMemberApi,
} from "../../../../../apis/api";
import { getApprovedMembers } from "../../../../../apis/api";
import { approve } from "../../../../../apis/api";
import { useNavigate, useLocation } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { useReactToPrint } from "react-to-print";
import { Dropdown } from "primereact/dropdown";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useDispatch, useSelector } from "react-redux";
import EligibleData from "./Eligible_members.json";
import { setMemberData, setTotal } from "../../../../../redux/member/memberReducer";
import moment from "moment/moment";

// ─── Inject styles once ───────────────────────────────────────────────────────
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

  :root {
    --clr-bg: #f4f5f7;
    --clr-surface: #ffffff;
    --clr-surface2: #f9fafb;
    --clr-border: #e5e7eb;
    --clr-border-strong: #d1d5db;
    --clr-accent: #2563eb;
    --clr-accent-light: #eff6ff;
    --clr-accent-hover: #1d4ed8;
    --clr-text: #111827;
    --clr-text-secondary: #6b7280;
    --clr-text-muted: #9ca3af;
    --clr-danger: #ef4444;
    --clr-success: #22c55e;
    --clr-warning: #f59e0b;
    --clr-success-bg: #f0fdf4;
    --clr-danger-bg: #fef2f2;
    --clr-warning-bg: #fffbeb;
    --radius-sm: 6px;
    --radius-md: 10px;
    --radius-lg: 16px;
    --shadow-sm: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04);
    --shadow-md: 0 4px 12px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04);
    --shadow-lg: 0 12px 32px rgba(0,0,0,0.10), 0 4px 12px rgba(0,0,0,0.06);
    --font: 'DM Sans', sans-serif;
    --font-mono: 'DM Mono', monospace;
    --transition: 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .lam-root * { box-sizing: border-box; font-family: var(--font); }
  .lam-root .pi { font-family: 'primeicons' !important; }

  /* ── Wrapper ── */
  .lam-root { background: var(--clr-bg); min-height: 100vh; padding: 0; }

  /* ── Top bar ── */
  .lam-topbar {
    background: var(--clr-surface);
    border-bottom: 1px solid var(--clr-border);
    padding: 18px 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    position: sticky;
    top: 0;
    z-index: 50;
    box-shadow: var(--shadow-sm);
  }
  .lam-topbar-left { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
  .lam-topbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

  .lam-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--clr-text);
    letter-spacing: -0.3px;
  }
  .lam-badge {
    background: var(--clr-accent-light);
    color: var(--clr-accent);
    font-size: 12px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 999px;
    font-family: var(--font-mono);
  }

  /* ── Stats pills ── */
  .lam-stats {
    display: flex;
    gap: 12px;
    padding: 0 28px 20px;
    margin-top: 20px;
    flex-wrap: wrap;
  }
  .lam-stat-card {
    background: var(--clr-surface);
    border: 1px solid var(--clr-border);
    border-radius: var(--radius-md);
    padding: 14px 20px;
    min-width: 160px;
    flex: 1;
    box-shadow: var(--shadow-sm);
    transition: box-shadow var(--transition), transform var(--transition);
  }
  .lam-stat-card:hover { box-shadow: var(--shadow-md); transform: translateY(-1px); }
  .lam-stat-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.8px; color: var(--clr-text-muted); margin-bottom: 4px; }
  .lam-stat-value { font-size: 26px; font-weight: 700; color: var(--clr-text); font-family: var(--font-mono); letter-spacing: -1px; }
  .lam-stat-card.accent { border-color: #bfdbfe; background: var(--clr-accent-light); }
  .lam-stat-card.accent .lam-stat-value { color: var(--clr-accent); }

  /* ── Toolbar ── */
  .lam-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 0 28px 18px;
    padding: 14px 16px;
    background: var(--clr-surface);
    border: 1px solid #e6e9f2;
    border-radius: 16px;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05), 0 2px 8px rgba(15, 23, 42, 0.04);
    flex-wrap: wrap;
  }
  .lam-toolbar-left { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .lam-toolbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

  /* ── Buttons ── */
  .lam-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 16px;
    border-radius: var(--radius-sm);
    font-size: 13.5px;
    font-weight: 600;
    font-family: var(--font);
    cursor: pointer;
    border: 1px solid transparent;
    transition: background var(--transition), border-color var(--transition), box-shadow var(--transition), transform var(--transition);
    white-space: nowrap;
    outline: none;
    line-height: 1;
  }
  .lam-btn:active { transform: scale(0.97); }

  .lam-btn-primary {
    background: var(--clr-accent);
    color: #fff;
    border-color: var(--clr-accent);
  }
  .lam-btn-primary:hover { background: var(--clr-accent-hover); border-color: var(--clr-accent-hover); box-shadow: 0 0 0 3px rgba(37,99,235,0.2); }

  .lam-btn-secondary {
    background: var(--clr-surface);
    color: var(--clr-text);
    border-color: var(--clr-border-strong);
  }
  .lam-btn-secondary:hover { background: var(--clr-surface2); border-color: #adb5bd; box-shadow: var(--shadow-sm); }

  .lam-btn-ghost {
    background: transparent;
    color: var(--clr-text-secondary);
    border-color: transparent;
  }
  .lam-btn-ghost:hover { background: var(--clr-surface2); color: var(--clr-text); }

  .lam-btn-danger {
    background: #fff5f5;
    color: var(--clr-danger);
    border-color: #fecaca;
  }
  .lam-btn-danger:hover { background: #fee2e2; }

  .lam-btn-icon {
    padding: 8px;
    border-radius: var(--radius-sm);
  }

  .lam-btn-sm { padding: 6px 12px; font-size: 12.5px; }

  /* Active filter badge on Filters btn */
  .lam-btn-filter-active {
    background: linear-gradient(180deg, #eef4ff 0%, #e4edff 100%);
    color: var(--clr-accent);
    border-color: #bfdbfe;
    box-shadow: 0 10px 18px rgba(37,99,235,0.12);
  }

  /* ── Type pills (outside filters) ── */
  .lam-type-pills {
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
    padding: 0;
    border-bottom: 1px solid #d7dce5;
  }
  .lam-type-pill {
    min-height: 44px;
    padding: 10px 18px 12px;
    border-radius: 0;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    border: none;
    border-bottom: 2px solid transparent;
    background: transparent;
    color: #66758f;
    transition: color var(--transition), border-color var(--transition);
    letter-spacing: -0.1px;
    white-space: nowrap;
    margin-bottom: -1px;
  }
  .lam-type-pill:hover {
    color: var(--clr-accent);
    background: transparent;
  }
  .lam-type-pill.active {
    background: transparent;
    border-bottom-color: #4f7cff;
    color: #4f7cff;
  }

  /* ── Search ── */
  .lam-search-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .lam-search-icon {
    position: absolute;
    left: 11px;
    color: var(--clr-text-muted);
    pointer-events: none;
    font-size: 14px;
  }
  .lam-search-input {
    padding: 11px 14px 11px 38px;
    border: 1px solid #d9dee8;
    border-radius: 14px;
    font-size: 14px;
    font-family: var(--font);
    color: var(--clr-text);
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
    width: 280px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.9);
    transition: border-color var(--transition), box-shadow var(--transition);
    outline: none;
  }
  .lam-search-input:focus { border-color: var(--clr-accent); box-shadow: 0 0 0 3px rgba(37,99,235,0.15); }
  .lam-search-input::placeholder { color: var(--clr-text-muted); }

  /* ── Sort icon button ── */
  .lam-sort-btn {
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid #d9dee8;
    border-radius: 14px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
    cursor: pointer;
    color: #5f6f8f;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.9);
    transition: all var(--transition);
  }
  .lam-sort-btn:hover {
    border-color: #bfd1ff;
    color: var(--clr-accent);
    background: #f7faff;
    transform: translateY(-1px);
  }

  /* ── Table card ── */
  .lam-table-card {
    margin: 0 28px 28px;
    background: var(--clr-surface);
    border: 1px solid var(--clr-border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
  }

  /* ── Count label ── */
  .lam-count-label {
    font-size: 12.5px;
    color: var(--clr-text-secondary);
    font-weight: 500;
    padding: 0 4px;
  }
  .lam-count-label strong { color: var(--clr-text); font-family: var(--font-mono); }

  /* ── Status badge ── */
  .lam-status {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
  .lam-status-approved { background: var(--clr-success-bg); color: #15803d; }
  .lam-status-rejected { background: var(--clr-danger-bg); color: #b91c1c; }
  .lam-status-pending { background: var(--clr-warning-bg); color: #92400e; }

  /* ── Modal ── */
  .lam-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(17, 24, 39, 0.4);
    backdrop-filter: blur(3px);
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    animation: lam-fade-in 0.18s ease;
  }
  @keyframes lam-fade-in { from { opacity: 0; } to { opacity: 1; } }

  .lam-modal {
    background: var(--clr-surface);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 580px;
    max-height: 90vh;
    overflow-y: auto;
    animation: lam-slide-up 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes lam-slide-up { from { opacity: 0; transform: translateY(20px) scale(0.97); } to { opacity: 1; transform: none; } }

  .lam-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 24px 18px;
    border-bottom: 1px solid var(--clr-border);
  }
  .lam-modal-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--clr-text);
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .lam-modal-title-icon {
    width: 32px; height: 32px;
    background: var(--clr-accent-light);
    border-radius: var(--radius-sm);
    display: flex; align-items: center; justify-content: center;
    color: var(--clr-accent);
    font-size: 14px;
  }
  .lam-modal-close {
    width: 32px; height: 32px;
    border-radius: var(--radius-sm);
    border: none;
    background: var(--clr-surface2);
    color: var(--clr-text-muted);
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    font-size: 16px;
    transition: all var(--transition);
  }
  .lam-modal-close:hover { background: var(--clr-danger-bg); color: var(--clr-danger); }

  .lam-modal-body { padding: 24px; display: flex; flex-direction: column; gap: 24px; }

  .lam-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid var(--clr-border);
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    background: var(--clr-surface2);
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  }

  /* ── Filter section ── */
  .lam-filter-section {}
  .lam-filter-section-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.9px;
    color: var(--clr-text-muted);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .lam-filter-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--clr-border);
  }

  /* ── Radio group ── */
  .lam-radio-group { display: flex; gap: 8px; flex-wrap: wrap; }
  .lam-radio-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border: 1.5px solid var(--clr-border);
    border-radius: 999px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: var(--clr-text-secondary);
    background: var(--clr-surface);
    transition: all var(--transition);
    user-select: none;
  }
  .lam-radio-pill:hover { border-color: var(--clr-accent); color: var(--clr-accent); background: var(--clr-accent-light); }
  .lam-radio-pill.selected { border-color: var(--clr-accent); color: var(--clr-accent); background: var(--clr-accent-light); font-weight: 600; }
  .lam-radio-pill input { display: none; }
  .lam-radio-dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    background: var(--clr-border-strong);
    transition: background var(--transition);
    flex-shrink: 0;
  }
  .lam-radio-pill.selected .lam-radio-dot { background: var(--clr-accent); }

  /* ── Dropdown select ── */
  .lam-select {
    padding: 8px 32px 8px 12px;
    border: 1.5px solid var(--clr-border);
    border-radius: var(--radius-sm);
    font-size: 13.5px;
    font-family: var(--font);
    color: var(--clr-text);
    background: var(--clr-surface) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236b7280' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") no-repeat right 10px center;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    transition: border-color var(--transition), box-shadow var(--transition);
    outline: none;
    width: 100%;
  }
  .lam-select:focus { border-color: var(--clr-accent); box-shadow: 0 0 0 3px rgba(37,99,235,0.15); }

  /* ── Date range ── */
  .lam-date-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .lam-date-label { font-size: 12px; font-weight: 600; color: var(--clr-text-secondary); margin-bottom: 5px; }
  .lam-date-input {
    width: 100%;
    padding: 8px 12px;
    border: 1.5px solid var(--clr-border);
    border-radius: var(--radius-sm);
    font-size: 13.5px;
    font-family: var(--font);
    color: var(--clr-text);
    background: var(--clr-surface);
    outline: none;
    transition: border-color var(--transition), box-shadow var(--transition);
  }
  .lam-date-input:focus { border-color: var(--clr-accent); box-shadow: 0 0 0 3px rgba(37,99,235,0.15); }

  /* ── Chip multi-select (for category/sort) ── */
  .lam-chip-grid { display: flex; flex-wrap: wrap; gap: 7px; }
  .lam-chip {
    padding: 6px 13px;
    border: 1.5px solid var(--clr-border);
    border-radius: var(--radius-sm);
    font-size: 12.5px;
    font-weight: 500;
    color: var(--clr-text-secondary);
    background: var(--clr-surface);
    cursor: pointer;
    transition: all var(--transition);
    white-space: nowrap;
  }
  .lam-chip:hover { border-color: var(--clr-accent); color: var(--clr-accent); background: var(--clr-accent-light); }
  .lam-chip.selected { border-color: var(--clr-accent); color: var(--clr-accent); background: var(--clr-accent-light); font-weight: 600; }

  /* ── Active filter count bubble ── */
  .lam-active-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px; height: 18px;
    background: var(--clr-accent);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    border-radius: 50%;
    margin-left: 2px;
  }

  /* ── Download dropdown ── */
  .lam-dropdown-wrap { position: relative; display: inline-block; }
  .lam-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: var(--clr-surface);
    border: 1px solid var(--clr-border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    min-width: 200px;
    z-index: 100;
    overflow: hidden;
    animation: lam-fade-in 0.15s ease;
  }
  .lam-dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    font-size: 13.5px;
    font-weight: 500;
    color: var(--clr-text);
    cursor: pointer;
    transition: background var(--transition);
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    font-family: var(--font);
  }
  .lam-dropdown-item:hover { background: var(--clr-surface2); }
  .lam-dropdown-item + .lam-dropdown-item { border-top: 1px solid var(--clr-border); }

  /* ── Divider ── */
  .lam-divider { height: 1px; background: var(--clr-border); margin: 4px 0; }

  /* PrimeReact DataTable light overrides */
  .lam-table-card .p-datatable .p-datatable-thead > tr > th {
    background: #f8fafc;
    color: var(--clr-text-secondary);
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    border-color: var(--clr-border);
    padding: 13px 16px;
  }
  .lam-table-card .p-datatable .p-datatable-tbody > tr > td {
    padding: 12px 16px;
    font-size: 13.5px;
    border-color: var(--clr-border);
    color: var(--clr-text);
  }
  .lam-table-card .p-datatable .p-datatable-tbody > tr:hover > td {
    background: #f8fafc;
  }
  .lam-table-card .p-paginator {
    border-top: 1px solid var(--clr-border);
    background: var(--clr-surface2);
    padding: 10px 16px;
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  }

  /* View button inside table */
  .lam-view-btn {
    padding: 5px 14px;
    background: var(--clr-accent-light);
    color: var(--clr-accent);
    border: 1.5px solid #bfdbfe;
    border-radius: var(--radius-sm);
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all var(--transition);
    font-family: var(--font);
  }
  .lam-view-btn:hover { background: var(--clr-accent); color: #fff; border-color: var(--clr-accent); }

  @media (max-width: 768px) {
    .lam-topbar, .lam-stats, .lam-toolbar { padding-left: 16px; padding-right: 16px; }
    .lam-table-card { margin: 0 16px 16px; }
    .lam-date-row { grid-template-columns: 1fr; }
  }
`;

// ─── inject once ───────────────────────────────────────────────────────────────
if (typeof document !== "undefined" && !document.getElementById("lam-styles")) {
  const s = document.createElement("style");
  s.id = "lam-styles";
  s.textContent = STYLES;
  document.head.appendChild(s);
}

// ─── FilterModal ───────────────────────────────────────────────────────────────
function FilterModal({ visible, onHide, state, handlers }) {
  const {
    membershipCategory, memberType,
    gstFilter, panFilter,
    admissionFrom, admissionTo,
    turnoverFilter, sortType,
    documentsFilter,
  } = state;

  const {
    setMembershipCategory, setMemberType,
    setGstFilter, setPanFilter,
    setAdmissionFrom, setAdmissionTo,
    setTurnoverFilter, setSortType,
    setDocumentsFilter,
    applyFilters, clearFilters,
  } = handlers;

  const industryOptions = [
    { label: "Small Scale Manufacturing", value: "ms" },
    { label: "Small Scale Trading", value: "ts" },
    { label: "Large Scale Manufacturing", value: "ml" },
    { label: "Large Scale Service", value: "sl" },
    { label: "Association", value: "as" },
    { label: "Small Scale Service", value: "ss" },
    { label: "Large Scale Trading", value: "tl" },
    { label: "District Chambers Of Commerce", value: "dc" },
    { label: "Profession", value: "pr" },
  ];

  const memberTypeOptions = [
    { label: "Ordinary", value: "ordinary" },
    { label: "Patron", value: "patron" },
  ];

  const sortOptions = [
    { label: "Member ID", value: "MEM_id_no" },
    { label: "Company Name", value: "name_of_org" },
    { label: "City", value: "city" },
    { label: "Pincode", value: "pincode" },
    { label: "M-Official", value: "LocalOnly" },
    { label: "All Data", value: "Alldata" },
  ];

  const turnoverOptions = [
    { label: "All", value: "all" },
    { label: "< 10 Cr", value: "lt10cr" },
    { label: "> 10 Cr", value: "gt10cr" },
  ];
  const documentsUploaded = [
    { label: "All", value: "all" },
    { label: "Submitted", value: "yes" },
    { label: "Not Submitted", value: "no" },
  ];

  if (!visible) return null;

  return (
    <div className="lam-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onHide(); }}>
      <div className="lam-modal">
        {/* Header */}
        <div className="lam-modal-header">
          <div className="lam-modal-title">
            <div className="lam-modal-title-icon"><i className="pi pi-sliders-h" /></div>
            Filters
          </div>
          <button className="lam-modal-close" onClick={onHide}>×</button>
        </div>

        {/* Body */}
        <div className="lam-modal-body">

          {/* Membership Category */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Membership Category</div>
            <div className="lam-chip-grid">
              <span
                className={`lam-chip ${!membershipCategory ? "selected" : ""}`}
                onClick={() => setMembershipCategory("")}
              >All</span>
              {industryOptions.map(o => (
                <span
                  key={o.value}
                  className={`lam-chip ${membershipCategory === o.value ? "selected" : ""}`}
                  onClick={() => setMembershipCategory(membershipCategory === o.value ? "" : o.value)}
                >{o.label}</span>
              ))}
            </div>
          </div>

          {/* Member Type */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Member Type</div>
            <div className="lam-radio-group">
              <label className={`lam-radio-pill ${!memberType ? "selected" : ""}`}>
                <input type="radio" checked={!memberType} onChange={() => setMemberType("")} />
                <span className="lam-radio-dot" />
                All
              </label>
              {memberTypeOptions.map(o => (
                <label key={o.value} className={`lam-radio-pill ${memberType === o.value ? "selected" : ""}`}>
                  <input type="radio" checked={memberType === o.value} onChange={() => setMemberType(o.value)} />
                  <span className="lam-radio-dot" />
                  {o.label}
                </label>
              ))}
            </div>
          </div>

          {/* GST & PAN */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Compliance</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <div>
                <div className="lam-date-label" style={{ marginBottom: 8 }}>GST Status</div>
                <div className="lam-radio-group">
                  {["all", "yes", "no"].map(v => (
                    <label key={v} className={`lam-radio-pill ${gstFilter === v ? "selected" : ""}`}>
                      <input type="radio" checked={gstFilter === v} onChange={() => setGstFilter(v)} />
                      <span className="lam-radio-dot" />
                      {v === "all" ? "All" : v === "yes" ? "Registered" : "Not Registered"}
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <div className="lam-date-label" style={{ marginBottom: 8 }}>PAN Status</div>
                <div className="lam-radio-group">
                  {["all", "yes", "no"].map(v => (
                    <label key={v} className={`lam-radio-pill ${panFilter === v ? "selected" : ""}`}>
                      <input type="radio" checked={panFilter === v} onChange={() => setPanFilter(v)} />
                      <span className="lam-radio-dot" />
                      {v === "all" ? "All" : v === "yes" ? "Available" : "Not Available"}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Admission Date Range */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Admission Date Range</div>
            <div className="lam-date-row">
              <div>
                <div className="lam-date-label">From</div>
                <input
                  type="date"
                  className="lam-date-input"
                  value={admissionFrom || ""}
                  onChange={(e) => setAdmissionFrom(e.target.value)}
                />
              </div>
              <div>
                <div className="lam-date-label">To</div>
                <input
                  type="date"
                  className="lam-date-input"
                  value={admissionTo || ""}
                  onChange={(e) => setAdmissionTo(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Turnover */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Turnover</div>
            <div className="lam-radio-group">
              {turnoverOptions.map(o => (
                <label key={o.value} className={`lam-radio-pill ${turnoverFilter === o.value ? "selected" : ""}`}>
                  <input type="radio" checked={turnoverFilter === o.value} onChange={() => setTurnoverFilter(o.value)} />
                  <span className="lam-radio-dot" />
                  {o.label}
                </label>
              ))}
            </div>
          </div>

          {/* Documents Submitted */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Documents Submitted</div>
            <div className="lam-radio-group">
              {documentsUploaded.map(v => (
                <label key={v.value} className={`lam-radio-pill ${documentsFilter === v.value ? "selected" : ""}`}>
                  <input type="radio" checked={documentsFilter === v.value} onChange={() => setDocumentsFilter(v.value)} />
                  <span className="lam-radio-dot" />
                  {v.label}
                </label>
              ))}
            </div>
          </div>

          {/* Sort By */}
          <div className="lam-filter-section">
            <div className="lam-filter-section-title">Sort By</div>
            <div className="lam-chip-grid">
              {sortOptions.map(o => (
                <span
                  key={o.value}
                  className={`lam-chip ${sortType === o.value ? "selected" : ""}`}
                  onClick={() => setSortType(o.value)}
                >{o.label}</span>
              ))}
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="lam-modal-footer">
          <button className="lam-btn lam-btn-ghost" onClick={clearFilters}>
            <i className="pi pi-times" style={{ fontSize: 13 }} />
            Reset All
          </button>
          <button className="lam-btn lam-btn-primary" onClick={() => { applyFilters(); onHide(); }}>
            <i className="pi pi-check" style={{ fontSize: 13 }} />
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── DownloadMenu ──────────────────────────────────────────────────────────────
function DownloadMenu({ onPrint, onExcel, onCityWise, loading }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="lam-dropdown-wrap" ref={ref}>
      <button className="lam-btn lam-btn-secondary" onClick={() => setOpen(!open)} disabled={loading}>
        {loading
          ? <><i className="pi pi-spin pi-spinner" style={{ fontSize: 13 }} /> Preparing...</>
          : <><i className="pi pi-download" style={{ fontSize: 13 }} /> Download <i className="pi pi-chevron-down" style={{ fontSize: 11 }} /></>
        }
      </button>
      {open && (
        <div className="lam-dropdown-menu">
          <button className="lam-dropdown-item" onClick={() => { onPrint(); setOpen(false); }}>
            <i className="pi pi-file-pdf" style={{ color: "#ef4444" }} /> Export as PDF
          </button>
          <button className="lam-dropdown-item" onClick={() => { onExcel(); setOpen(false); }}>
            <i className="pi pi-file-excel" style={{ color: "#22c55e" }} /> Export as Excel
          </button>
          <div className="lam-divider" />
          <button className="lam-dropdown-item" onClick={() => { onCityWise(); setOpen(false); }}>
            <i className="pi pi-map-marker" style={{ color: "#6366f1" }} /> City Wise Count
          </button>
        </div>
      )}
    </div>
  );
}

// ─── Main Component ────────────────────────────────────────────────────────────
function ListAllMembers() {
  const toast = useRef(null);
  const navigate = useNavigate();
  const memberRef = useRef(null);
  const memberRefforExcel = useRef(null);
  const eligibleRef = useRef(null);
  const cityRefforExcel = useRef(null);

  const [update, setUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [url, setUrl] = useState(null);
  const [url2, setUrl2] = useState(null);
  const [newUrl, setNewUrl] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [basicFirst, setBasicFirst] = useState(0);
  const [basicRows, setBasicRows] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [excelData, setExcelData] = useState([]);
  const [excelDataCityWise, setExcelDataCityWise] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isLoading2, setLoading2] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [allMemberCount, setAllMemberCount] = useState(0);
  const [approvedMemberCount, setApprovedMemberCount] = useState(0);
  const [orderBy, setOrderBy] = useState("ASC");
  const [selectedProducts, setSelectedProducts] = useState([]);

  const { memberData, isRefresh, total } = useSelector((state) => state.member);
  const dispatch = useDispatch();

  // ── Type filter (stays OUTSIDE modal) ──
  const [type, setType] = useState("All");
  const [typeLable, setTypeLable] = useState("All Members");

  // ── All other filters (INSIDE modal) ──
  const [membershipCategory, setMembershipCategory] = useState("");
  const [memberType, setMemberType] = useState("");
  const [gstFilter, setGstFilter] = useState("all");
  const [panFilter, setPanFilter] = useState("all");
  const [admissionFrom, setAdmissionFrom] = useState("");
  const [admissionTo, setAdmissionTo] = useState("");
  const [turnoverFilter, setTurnoverFilter] = useState("all");
  const [sortType, setSortType] = useState("MEM_id_no");
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [documentsFilter, setDocumentsFilter] = useState("all");
  // count active filters for the badge
  const activeFilterCount = [
    membershipCategory,
    memberType,
    gstFilter !== "all" ? gstFilter : "",
    panFilter !== "all" ? panFilter : "",
    admissionFrom,
    admissionTo,
    turnoverFilter !== "all" ? turnoverFilter : "",
    documentsFilter !== "all" ? documentsFilter : "",
    sortType !== "MEM_id_no" ? sortType : "",
  ].filter(Boolean).length;

  // ── Build URL from current filter state ──
  const buildUrl = (cat, mType, gst, pan, from, to, turnover, documents) => {
    let u = "";
    if (cat) u += `&industry=${cat}`;
    if (mType) u += `&memberCategory=${mType}`;
    if (gst && gst !== "all") u += `&gst=${gst}`;
    if (pan && pan !== "all") u += `&pan=${pan}`;
    if (from) u += `&admissionFrom=${from}`;
    if (to) u += `&admissionTo=${to}`;
    if (turnover && turnover !== "all") u += `&turnover=${turnover}`;
    if (documents && documents !== "all") u += `&documentsSubmitted=${documents}`;
    return u;
  };

  const applyFilters = () => {
    const u = buildUrl(membershipCategory, memberType, gstFilter, panFilter, admissionFrom, admissionTo, turnoverFilter, documentsFilter);
    setNewUrl(u);
    setCurrentPage(0);
    setBasicFirst(0);
    setUpdate((p) => !p);
  };

  const clearFilters = () => {
    setMembershipCategory("");
    setMemberType("");
    setGstFilter("all");
    setPanFilter("all");
    setAdmissionFrom("");
    setAdmissionTo("");
    setTurnoverFilter("all");
    setDocumentsFilter("all");
    setSortType("MEM_id_no");
    setNewUrl("");
    setCurrentPage(0);
    setBasicFirst(0);
    setSelectedProducts([]);
    setUpdate((p) => !p);
  };

  const clearAll = () => {
    clearFilters();
    setType("All");
    setTypeLable("All Members");
    setOrderBy("ASC");
    setIsSearch(false);
    setSelectedProducts([]);
  };

  useEffect(() => {
    setSelectedProducts([]); // reset row selection on filter/type/page changes
    if (isRefresh) {
      setLoading(true);
      getApprovedMembers(currentPage, basicRows, orderBy, newUrl, type, sortType)
        .then((res) => {
          setData(res.results);
          console.log("Fetched members:", res);
          setTotalRecords(res.total);
          dispatch(setMemberData(res.results));
          dispatch(setTotal(res.total));
        })
        .catch(console.error)
        .finally(() => setLoading(false));
      cityWiseData();
    } else {
      setLoading(false);
      setTotalRecords(total);
    }
  }, [update, currentPage, basicRows, newUrl, orderBy, type, isRefresh, total, sortType]);

  useEffect(() => { getCount(); }, []);

  const getCount = () => {
    getMemberCount()
      .then((res) => { setAllMemberCount(res?.totalCount); setApprovedMemberCount(res?.approvedCount); })
      .catch(console.error);
  };

  const pageStyle = `@media print { @page { size: 210mm 297mm; margin: 0; } }`;

  const handleMemberPrint = useReactToPrint({ pageStyle, content: () => memberRef.current });

  const getAlldata = async (total, pType) => {
    setLoading2(true);
    if (selectedProducts.length) {
      pType === "print" ? handleMemberPrint() : handleMemberExcelPrint.onDownload();
      setLoading2(false);
    } else {
      getApprovedMembers(0, totalRecords || 99999, orderBy, newUrl, type, sortType)
        .then((res) => {
          setExcelData(res?.results || []);
          setTimeout(() => {
            pType === "print" ? handleMemberPrint() : handleMemberExcelPrint.onDownload();
            setLoading2(false);
          }, 1000);
        })
        .catch((err) => { console.error(err); setLoading2(false); });
    }
  };

  const getFilteredData = (val) => {
    setLoading(true);
    searchMemberApi(val).then((res) => {
      if (Array.isArray(res)) {
        setExcelData(res);
        setData(res);
        setTotalRecords(res.length);
        dispatch(setMemberData(res));
        setUrl2(`&key=${val}`);
        setIsSearch(true);
      }
    }).finally(() => setLoading(false));
  };

  const cityWiseData = async () => { setExcelDataCityWise(await getCityWiseCount()); };

  const handleMemberExcelPrint = useDownloadExcel({ currentTableRef: memberRefforExcel.current, filename: "FKCCI Members", sheet: "Members" });
  const handleCityWiseCountExcelPrint = useDownloadExcel({ currentTableRef: cityRefforExcel.current, filename: "FKCCI City wise count", sheet: "Members" });
  const handleEligibleExcelPrint = useDownloadExcel({ currentTableRef: eligibleRef.current, filename: "Eligible_FKCCI", sheet: "Members" });

  const typeOptions = [
    { label: "All Members", value: "All" },
    { label: "Approved Members", value: "Approved" },
    { label: "Active Members", value: "Active" },
    { label: "DeActive Members", value: "DeActive" },
    { label: "Paid Members", value: "Paid" },
    { label: "Due 1 Year", value: "Due1Year" },
    { label: "Due 2+ Years", value: "Due2Plus" },
  ];

  const onBasicPageChange = (event) => {
    setBasicFirst(event.first);
    setBasicRows(event.rows);
    setCurrentPage(event.page);
  };

  // ── Column renderers ──
  const approvalStatus = (rowData) => {
    const cls = rowData.status === "APPROVED" ? "lam-status-approved" : rowData.status === "REJECTED" ? "lam-status-rejected" : "lam-status-pending";
    return <span className={`lam-status ${cls}`}>{rowData.status}</span>;
  };

  const makeClickable = (content, member_id) => (
    <div className="capitalize" style={{ cursor: "pointer", color: "var(--clr-text)" }} onClick={() => navigate("/userManagement/memberDetails", { state: member_id })}>{content}</div>
  );

  const viewApplicationField = (data) => (
    <button className="lam-view-btn" onClick={() => navigate("/userManagement/memberDetails", { state: data.member_id })}>View</button>
  );

  const formatRepName = (d, idx) => {
    const first = d[`representative${idx}_first_name`];
    const middle = d[`representative${idx}_middle_name`];
    const last = d[`representative${idx}_last_name`];
    const parts = [first, middle, last].filter(Boolean);
    if (parts.length) return parts.join(" ");
    return d[`name_of_representative${idx}`] || "-";
  };

  const formatRepNameInline = (val, idx) => {
    const first = val?.[`representative${idx}_first_name`];
    const middle = val?.[`representative${idx}_middle_name`];
    const last = val?.[`representative${idx}_last_name`];
    const parts = [first, middle, last].filter(Boolean);
    if (parts.length) return parts.join(" ");
    return val?.[`name_of_representative${idx}`] || "";
  };

  return (
    <div className="lam-root">
      <Toast ref={toast} />

      {/* ── Top bar ── */}
      <div className="lam-topbar">
        <div className="lam-topbar-left">
          <span className="lam-title">Member Directory</span>
          {/* <span className="lam-badge">{approvedMemberCount} approved</span> */}
        </div>
        <div className="lam-topbar-right">
          <DownloadMenu
            onPrint={() => getAlldata(totalRecords, "print")}
            onExcel={() => getAlldata(totalRecords, "excel")}
            onCityWise={handleCityWiseCountExcelPrint.onDownload}
            loading={isLoading2}
          />
          <button className="lam-btn lam-btn-danger" onClick={clearAll}>
            <i className="pi pi-times" style={{ fontSize: 13 }} /> Clear All
          </button>
        </div>
      </div>

      {/* ── Stats ── */}
      <div className="lam-stats">
        {/* <div className="lam-stat-card accent">
          <div className="lam-stat-label">Approved Members</div>
          <div className="lam-stat-value">{approvedMemberCount?.toLocaleString()}</div>
        </div> */}
        <div className="lam-stat-card accent">
          <div className="lam-stat-label">Total Members</div>
          <div className="lam-stat-value">{allMemberCount}</div>
        </div>
        <div className="lam-stat-card">
          <div className="lam-stat-label">{typeLable}</div>
          {console.log("Total records for current view:", allMemberCount)}
          {console.log("Total records for current view:", totalRecords)}
          <div className="lam-stat-value">{totalRecords}</div>
        </div>
        <div className="lam-stat-card">
          <div className="lam-stat-label">Selected</div>
          <div className="lam-stat-value">{selectedProducts.length}</div>
        </div>
      </div>

      {/* ── Toolbar ── */}
      <div className="lam-toolbar">
        {/* Left: type pills + search + filters button */}
        <div className="lam-toolbar-left">
          {/* Type pills (stay outside) */}
          <div className="lam-type-pills">
            {typeOptions.map(o => (
              <span
                key={o.value}
                className={`lam-type-pill ${type === o.value ? "active" : ""}`}
                onClick={() => { setType(o.value); setTypeLable(o.label); setCurrentPage(0); setBasicFirst(0); }}
              >{o.label}</span>
            ))}
          </div>

          {/* Separator */}
          <div style={{ width: 1, height: 28, background: "var(--clr-border)", margin: "0 4px" }} />

          {/* Search */}
          <div className="lam-search-wrap">
            <i className="pi pi-search lam-search-icon" />
            <input
              type="text"
              className="lam-search-input"
              placeholder="Search members..."
              onChange={(e) => {
                if (e.target.value?.length >= 4) getFilteredData(e.target.value);
                else if (e.target.value?.length === 0) setUpdate((p) => !p);
              }}
            />
          </div>

          {/* Sort toggle */}
          <button
            className="lam-sort-btn"
            title={orderBy === "ASC" ? "Sort Descending" : "Sort Ascending"}
            onClick={() => setOrderBy(orderBy === "ASC" ? "DESC" : "ASC")}
          >
            <i className={`pi ${orderBy === "ASC" ? "pi-sort-amount-up" : "pi-sort-amount-down"}`} />
          </button>

          {/* Filters button */}
          <button
            className={`lam-btn ${activeFilterCount > 0 ? "lam-btn-filter-active" : "lam-btn-secondary"}`}
            onClick={() => setFilterModalVisible(true)}
          >
            <i className="pi pi-sliders-h" style={{ fontSize: 13 }} />
            Filters
            {activeFilterCount > 0 && <span className="lam-active-badge">{activeFilterCount}</span>}
          </button>
        </div>

        {/* Right: record count */}
        <div className="lam-count-label">
          Showing <strong>{Math.min(basicRows, totalRecords - basicFirst)}</strong> of <strong>{totalRecords}</strong> records
        </div>
      </div>

      {/* ── Table ── */}
      <div className="lam-table-card">
        <DataTable
          value={memberData}
          showGridlines
          loading={isLoading}
          selectionMode="checkbox"
          selection={selectedProducts}
          onSelectionChange={(e) => setSelectedProducts(e.value)}
          emptyMessage={<div style={{ textAlign: "center", padding: "48px 0", color: "var(--clr-text-muted)" }}><i className="pi pi-inbox" style={{ fontSize: 32, display: "block", marginBottom: 8 }} />No members found</div>}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
          <Column field="MEM_id_no" header="MEM ID No" style={{ fontFamily: "var(--font-mono)", fontSize: 13, width: "120px" }} />
          <Column header="Name Of Organization" body={(d) => makeClickable(d.name_of_org, d.member_id)} style={{ minWidth: "220px" }} />
          <Column
            header="Representative 1"
            body={(d) => (
              <div style={{ width: '100%', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                <div>{formatRepName(d, 1)}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.designation_of_representative1 || "-"}</div>
                <div style={{ fontSize: 12 }}>{d.mobile || "-"}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.email_of_representative1 || "-"}</div>
              </div>
            )}
            style={{ minWidth: "220px" }}
          />
          <Column
            header="Representative 2"
            body={(d) => (
              <div style={{ width: '100%', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                <div>{formatRepName(d, 2)}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.designation_of_representative2 || "-"}</div>
                <div style={{ fontSize: 12 }}>{d.mobile_of_repr2 || "-"}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.email_of_representative2 || "-"}</div>
              </div>
            )}
            style={{ minWidth: "220px" }}
          />
          <Column
            header="Representative 3"
            body={(d) => (
              <div style={{ width: '100%', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                <div>{formatRepName(d, 3)}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.designation_of_representative3 || "-"}</div>
                <div style={{ fontSize: 12 }}>{d.mobile_of_repr3 || "-"}</div>
                <div style={{ fontSize: 12, color: "var(--clr-text-muted)" }}>{d.email_of_representative3 || "-"}</div>
              </div>
            )}
            style={{ minWidth: "220px" }}
          />
          <Column header="Membership Category" body={(d) => makeClickable(d.membership_category, d.member_id)} style={{ minWidth: "170px" }} />
          <Column header="Member Type" body={(d) => makeClickable(d.member_category, d.member_id)} style={{ minWidth: "140px" }} />
          <Column header="Action" body={viewApplicationField} style={{ width: "120px" }} />
        </DataTable>
        <Paginator
          first={basicFirst}
          totalRecords={total}
          rows={basicRows}
          onPageChange={onBasicPageChange}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </div>

      {/* ── Filters Modal ── */}
      <FilterModal
        visible={filterModalVisible}
        onHide={() => setFilterModalVisible(false)}
        state={{ membershipCategory, memberType, gstFilter, panFilter, admissionFrom, admissionTo, turnoverFilter, sortType, documentsFilter }}
        handlers={{ setMembershipCategory, setMemberType, setGstFilter, setPanFilter, setAdmissionFrom, setAdmissionTo, setTurnoverFilter, setSortType, setDocumentsFilter, applyFilters, clearFilters }}
      />

      {/* ── Hidden print/excel tables ── */}
      <div style={{ display: "none" }}>
        <div ref={memberRef} style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(63.5mm, 1fr))", gridAutoRows: "max-content", paddingTop: "1mm", paddingRight: "8mm" }}>
          {(selectedProducts.length ? selectedProducts : excelData).map((item, index) => (
            <div key={index} style={{ marginTop: index % 24 <= 2 ? "11.5mm" : "0px", height: "34.125mm", padding: "2px 5px 0px 20px", borderRadius: "20px", overflow: "hidden" }}>
              <p style={{ fontSize: "0.7em", lineHeight: "14px" }}>{item?.MEM_id_no}</p>
              <p style={{ fontSize: "0.7em", fontWeight: 400, lineHeight: "14px", wordBreak: "break-word" }}>{item?.name_of_org}</p>
              <p style={{ fontSize: "0.7em", fontWeight: 400, lineHeight: "14px", wordBreak: "break-word" }}>{item?.address}</p>
              <p style={{ fontSize: "0.7em", fontWeight: 400, lineHeight: "14px" }}>{item?.city} - {item?.pincode}</p>
              <p style={{ fontSize: "0.7em", fontWeight: 400, lineHeight: "14px" }}>Phone: {item?.phone_number}</p>
              <p style={{ fontSize: "0.7em", fontWeight: 400, lineHeight: "14px" }}>Mobile: {item?.mobile}</p>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: "none" }}>
        <table ref={memberRefforExcel} border="1">
          <thead><tr><th>Member Id</th><th>Company Name</th><th>Address</th><th>City</th><th>Pincode</th><th>State</th><th>Office No.</th><th>Fax</th><th>Mobile No1</th><th>Mobile No2</th><th>Mobile No3</th><th>Email</th><th>Rep 1 Name</th><th>Rep 1 Designation</th><th>Rep 1 Email</th><th>Rep 2 Name</th><th>Rep 2 Designation</th><th>Rep 2 Email</th><th>Rep 3 Name</th><th>Rep 3 Designation</th><th>Rep 3 Email</th><th>Product</th><th>Status</th><th>Date of Admission</th><th>Date of Estd.</th><th>Membership Category</th><th>Member Tag</th><th>Website</th><th>GSTIN</th><th>CIN No.</th><th>PAN</th><th>Proposed By</th><th>Seconded By</th><th>Introducer</th><th>Turnover</th></tr></thead>
          <tbody>
            {(selectedProducts.length ? selectedProducts : excelData).map((val, i) => (
              <tr key={i}>
                <td>{val.MEM_id_no}</td><td>{val.name_of_org}</td><td>{val?.address}</td><td>{val?.city}</td><td>{val?.pincode}</td><td>{val?.state}</td><td>{val?.phone_number}</td><td>{val?.fax}</td><td>{val?.mobile}</td><td>{val?.mobile_of_repr2}</td><td>{val?.mobile_of_repr3}</td><td>{val?.email}</td><td>{formatRepNameInline(val, 1)}</td><td>{val?.designation_of_representative1}</td><td>{val?.email_of_representative1}</td><td>{formatRepNameInline(val, 2)}</td><td>{val?.designation_of_representative2}</td><td>{val?.email_of_representative2}</td><td>{formatRepNameInline(val, 3)}</td><td>{val?.designation_of_representative3}</td><td>{val?.email_of_representative3}</td><td>{val?.description}</td><td>{val?.status}</td>
                <td>{val?.date_of_admission ? moment(val.date_of_admission).format("DD-MM-YYYY") : ""}</td>
                <td>{val?.date_of_estd ? moment(val.date_of_estd).format("DD-MM-YYYY") : ""}</td>
                <td>{val?.membership_category}</td><td>{val?.member_category}</td><td>{val?.website}</td><td>{val?.GSTIN}</td><td>{val?.cin_no}</td><td>{val?.PAN}</td><td>{val?.proposed_by}</td><td>{val?.seconded_by}</td><td>{val?.introducer_name}</td><td>{val?.annual_turnover}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "none" }}>
        <table ref={cityRefforExcel} border="1">
          <thead><tr><th>City</th><th>Pincode</th><th>Count Of Members</th></tr></thead>
          <tbody>{excelDataCityWise?.map((val, i) => <tr key={i}><td>{val.city}</td><td>{val.pincode}</td><td>{val?.num_members}</td></tr>)}</tbody>
        </table>
      </div>

      <div style={{ display: "none" }}>
        <table ref={eligibleRef} border="1">
          <thead><tr><th>Member Id</th><th>RFID 1</th><th>RFID 2</th><th>RFID 3</th><th>Company Name</th><th>Address</th><th>City</th><th>Pincode</th><th>State</th><th>Office No.</th><th>Fax</th><th>Mobile No.</th><th>Email</th><th>Rep 1 Name</th><th>Rep 1 Designation</th><th>Rep 2 Name</th><th>Rep 2 Designation</th><th>Rep 3 Name</th><th>Rep 3 Designation</th><th>Product</th></tr></thead>
          <tbody>{EligibleData?.map((val, i) => <tr key={i}><td>{val?.Member_Id}</td><td>{String(val?.RFID_1)}</td><td>{String(val?.RFID_2)}</td><td>{String(val?.RFID_3)}</td><td>{val?.ComponyName}</td><td>{val?.Address}</td><td>{val?.City}</td><td>{val?.Pincode}</td><td>{val?.State}</td><td>{val?.Office_No}</td><td>{val?.Fax}</td><td>{val?.Mobile_No}</td><td>{val?.Email}</td><td>{val?.Name_1}</td><td>{val?.Designation_1}</td><td>{val?.Name_2}</td><td>{val?.Designation_2}</td><td>{val?.Name_3}</td><td>{val?.Designation_3}</td><td>{val?.Product}</td></tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}

export default ListAllMembers;
